import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { MatDialog } from "@angular/material/dialog";

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { ExcelService } from 'src/app/service/utilitarios/excel.service';
import { MaePlantillaService } from 'src/app/service/mae-plantilla.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { MaePlantillaM} from 'src/app/model/mae-plantilla-bean'
import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';
import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { ComboM } from 'src/app/model/combo-bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { EliminarDml } from 'src/app/model/estadoDml';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { saveAs } from 'file-saver';

import { DmlPlantillaComponent } from 'src/app/pagina-admin/dashboard/gestion-plantilla/dml-plantilla/dml-plantilla.component';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';
import { Console } from 'console';

@Component({
  selector: 'app-gestion-plantilla',
  templateUrl: './gestion-plantilla.component.html',
  styleUrls: ['./gestion-plantilla.component.scss']
})
export class GestionPlantillaComponent implements OnInit {

  constructor(
    private maePlantillaService:MaePlantillaService,
    private detArchivoService:DetArchivoService,
    private globalVariablesService:GlobalVariablesService,
    private maeTablaService:MaeTablaService,
    private excelService:ExcelService,
    private utilitarioService:UtilitarioService,
    private modalService: MDBModalService,
    private dialogo: MatDialog,
    private httpclient:HttpClient,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  //filtro
  txt_nombres:String = "";
  cboOrgano:String = "";
  cboEstado:String = "";

  listEstado= new Array<Mae_tabla_E>();
  listOrgano= new Array<Mae_tabla_E>();
  listPlantillas = new Array<MaePlantillaM>();

  //modal
  modalRefUsuarioDml: MDBModalRef;

  headElements = ['Nro','Nombre','Descripcion','Estado','Descargar','Eliminar','Editar'];


  page = 1;
  pageSize = 9;

  eliminadoDml = new EliminarDml();

  ngOnInit(): void {
    if(this.globalVariablesService.getC_perfil() == "2"){ //firmante
      this.router.navigate(['../inicio'],{relativeTo:this.route});
    }
    else
    {
    const cargarEstado = this.maeTablaService.getList("ESTADO_REGISTRO").toPromise()
    .then(result => {
      this.listEstado = result;
    });

    Promise.all([cargarEstado])
      .then(response => {
        this.onBuscar();
        this.utilitarioService.loading = false;

      })
    .catch(error => console.log(`Error in executing ${error}`));
    }
  }

  onBuscar(){

    this.utilitarioService.loading = true;

    var nombres = "*";
    if(this.txt_nombres.toString().length>0)    nombres = this.txt_nombres.toString();

    var estado = "0";
    if(this.cboEstado.toString().length>0)      estado = this.cboEstado.toString();

    console.log("nombres->"+nombres+",estado->"+estado)

    this.maePlantillaService.getfind(nombres,estado).subscribe(data=>{
      this.listPlantillas = data;
      this.utilitarioService.loading = false;
    });

  }

  onNuevo(){
    this.modalRefUsuarioDml = this.modalService.show(DmlPlantillaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: 0,
          x_titulo:'Nueva Plantilla',
          x_proceso:'I',
          seactualiza:true,
          esupdate:false,
        }
      }
    );

    this.modalRefUsuarioDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }else{
        this.utilitarioService.toastrError(result.mensaje);
      }

    });

  }

  onEditar(maePlantillaM:MaePlantillaM){
    this.modalRefUsuarioDml = this.modalService.show(DmlPlantillaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: maePlantillaM.c_plantilla,
          x_titulo:'Editar Plantilla',
          x_proceso:'U',
          seactualiza:false,
          esupdate:true,
        }
      }
    );

    this.modalRefUsuarioDml.content.action.subscribe( (result: Response_dml_bean) =>
    {

      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }else{
        this.utilitarioService.toastrError(result.mensaje);
      }

    });

  }

  onEliminar(maePlantillaM:MaePlantillaM){

    const limit = 1 as Number;
    if(maePlantillaM.c_plantilla>limit)
    {
      this.dialogo.open(ConfirmarsionoComponent, {
        data: { mensaje: '¿Desea dar de baja la plantilla seleccionada?'},
        width: '550px'
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {

        if (confirmado) {

          let auditoriaBeanM = new AuditoriaBeanM();
          auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio("D");
          this.eliminadoDml.auditoriaBeanM =auditoriaBeanM;
          this.eliminadoDml.x_tabla = "MAE_PLANTILLA"; //en proceso de evaluacion
          this.eliminadoDml.c_id = String(maePlantillaM.c_plantilla);
          this.eliminadoDml.b_eliminado = "1";


          this.utilitarioService.loading = true;
          console.log(this.eliminadoDml);

          this.maeTablaService.deleteDML(this.eliminadoDml).subscribe(result=>{
            if (result.codigoRespuestaServicio=="1"){
              this.utilitarioService.toastrSuccess(result.mensaje);
              this.onBuscar();
            }else{
              this.utilitarioService.toastrWarning(result.mensaje);
            };

            this.utilitarioService.loading = false;
          });

        } else {
          return;
        }
      });
    }
    else{
      this.utilitarioService.toastrWarning("No puede dar de baja esta plantilla.");
    }
  }

  onDescargar(maePlantillaM:MaePlantillaM){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(maePlantillaM.x_uid.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,maePlantillaM.x_nombre.toString()+maePlantillaM.x_archivo_ext.toString());
    });

  }
}
